import { QueryCache, QueryClient } from "@tanstack/react-query";
import Toast from "../components/Toast";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (_, query) => {
      if (typeof query.meta?.errorMessage === "string") {
        Toast.error(query.meta.errorMessage);
      }
    },
  }),
});
